import { listingDescription } from "../../../../components/Input/InstrumentSearch";
import {
  ASSET_TYPES,
  AssetType,
  DiscoveredListing,
} from "../../../../services/instruments";
import { COUNTRY_OPTIONS } from "../../../../utils/countries";
import { PairAssetType } from "../../../../services/tickerRequests";
import { MethodOption } from "./types";

export const METHOD_OPTIONS: MethodOption[] = [
  { label: "Existing", value: "EXISTING" },
  { label: "Yahoo listing", value: "LISTED" },
  { label: "Pair", value: "PAIR" },
  { label: "Manual", value: "MANUAL" },
];

export const PAIR_EXCHANGES: Record<PairAssetType, string> = {
  CRYPTO: "CRYPTO",
  FOREX: "FX",
};

export const isPairAssetType = (assetType: AssetType) =>
  assetType in PAIR_EXCHANGES;

const assetTypeOption = (assetType: AssetType) => ({
  label: assetType,
  value: assetType,
});

export const PAIR_ASSET_TYPE_OPTION_OF = {
  CRYPTO: assetTypeOption("CRYPTO"),
  FOREX: assetTypeOption("FOREX"),
};

export const PAIR_ASSET_TYPE_OPTIONS = Object.values(PAIR_ASSET_TYPE_OPTION_OF);

export const FOREX_REQUEST_EXCHANGES = [PAIR_EXCHANGES.FOREX, "FOREX"];

export const MANUAL_ASSET_TYPE_OPTIONS = ASSET_TYPES.map(assetTypeOption);

export const countryOptionOf = (countryCode: string | null) =>
  COUNTRY_OPTIONS.find(({ value }) => value === countryCode) ?? null;

export const NOT_SET = "Not set";

export const countryLabelOf = (sourceCountry: string | null) =>
  countryOptionOf(sourceCountry)?.label ?? sourceCountry ?? NOT_SET;

export const pricingLabelOf = (
  manualPricingOnly: boolean,
  yahooSymbol: string | null,
) => {
  if (manualPricingOnly) {
    return "Manual only";
  }
  return yahooSymbol ?? NOT_SET;
};

export const listingOptionOf = (listing: DiscoveredListing) => ({
  value: listing.yahooSymbol,
  label: listingDescription(listing),
});

export const soleListingOptionOf = (candidates: DiscoveredListing[]) =>
  candidates.length === 1 ? listingOptionOf(candidates[0]) : null;

const requiredText = (label: string, maxLength: number) => ({
  validate: (value: string) => value.trim() !== "" || `${label} is required`,
  maxLength: {
    value: maxLength,
    message: `${label} must be at most ${maxLength} characters`,
  },
});

export const SYMBOL_RULES = requiredText("Symbol", 20);
export const EXCHANGE_RULES = requiredText("Exchange", 20);
export const NAME_RULES = {
  maxLength: { value: 100, message: "Name must be at most 100 characters" },
};
export const CURRENCY_RULES = {
  validate: (value: string) =>
    /^[A-Za-z]{3}$/.test(value.trim()) ||
    "Currency must be a 3-letter ISO 4217 code",
};
